import api from './api';

/**
 * Fetch a one-time WebSocket authentication ticket from the backend.
 * The ticket is valid for 30 seconds and can only be used once.
 *
 * @returns {Promise<string>} The ticket UUID
 */
export const getWebSocketTicket = async () => {
  const response = await api.post('/common/ws/ticket/');
  return response.data.ticket;
};
